import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/user_member`;
export default {
  /***
   * 用户绑定卡数信息
   */
  bindCardNumber() {
    return axios({
      url: `${_MODULE}/bind/card/number`,
      method: `GET`
    })
  },
  /***
   * 请求绑定会员
   */
  applyBind(data) {
    return axios({
      url: `${_MODULE}/apply/bind`,
      method: `POST`,
      data,
      // errorHandle: false
    })
  },
  /***
   * 用户绑定会员卡信息
   */
  bindCardInfo(params) {
    return axios({
      url: `${_MODULE}/bind/card/info`,
      method: `GET`,
      params
    })
  },
  /***
   * 解绑会员
   */
  unbind(params) {
    return axios({
      url: `${_MODULE}/${params.memberUserRelationId}/unbind`,
      method: `PUT`
    })
  },
  /***
   * 申请绑定家人会员卡列表
   */
  bindFamilyCardList() {
    return axios({
      url: `${_MODULE}/bind/family/card/list`,
      method: `GET`
    })
  },
  /***
   * 【会员卡充值】微信支付
   */
  rechargeWechatPay(data) {
    return axios({
      url: `${_MODULE}/recharge/wechat_pay`,
      method: `POST`,
      data
    })
  },
  /***
   * 用户会员卡支付列表
   */
  payList(data) {
    return axios({
      url: `${_MODULE}/pay/list`,
      method: `POST`,
      data
    })
  },
  /***
   * 根据会员卡id获取会员数据
   */
  memberCardInfo(params) {
    return axios({
      url: `${_MODULE}/${params.payCardId}/memberCardInfo`,
      method: `POST`,
    })
  },
}


// WEBPACK FOOTER //
// ./src/apis/src/userMemberRelation.js